"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reasonToChangeInventoryExtractor = void 0;
var reasonToChangeInventoryExtractor = function (response) {
    return response.reasons_to_change_inventories;
};
exports.reasonToChangeInventoryExtractor = reasonToChangeInventoryExtractor;
//# sourceMappingURL=ReasonToChangeInventory.consts.js.map